import Header from "../layouts/header";
import Title from "../components/title";
import Footer from "../components/footer";
import ContactForm from "../components/contact/contact-form";
import { useTranslation } from "react-i18next";
import React, { createContext, useState, useEffect } from "react";
import CookiePolicyData from "../components/policy/cookie-policy";
import { Helmet } from "react-helmet-async";

export default function CookiePolicy(props) {
  const [t, i18next] = useTranslation("global");
  const language = localStorage.getItem("i18nextLng") || "es";
  useEffect(() => {
    document.body.classList.remove("dark-mode");
    document.title = "Politicas de cookies - SAX";

    // Cambiar la meta descripción
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "Aprende todo sobre las cookies en tu navegador: qué son, cómo funcionan y cómo gestionarlas para mejorar tu experiencia en línea. Encuentra consejos útiles y guías paso a paso"
      );
    } else {
      const newMetaDescription = document.createElement("meta");
      newMetaDescription.name = "description";
      newMetaDescription.content =
        "Aprende todo sobre las cookies en tu navegador: qué son, cómo funcionan y cómo gestionarlas para mejorar tu experiencia en línea. Encuentra consejos útiles y guías paso a paso";
      document.head.appendChild(newMetaDescription);
    }
  }, []);

  return (
    <>
      <Helmet>
        <link rel="canonical" href="https://sax.com.co/politicadecookies" />
      </Helmet>
      <Header {...props} />
      <Title title={t(`policy.cookies.title`)} />
      <CookiePolicyData />
      <Footer />
    </>
  );
}
